export default {
  all_categories: 'All Categories',
  navigation: {
    anchors: {
      about: {
        community: 'in-the-community',
        'directors-board': 'board-of-directors',
        intro: 'who-are-we',
        'our-purpose': 'our-purpose',
        overview: 'overview',
        products: 'product-lines',
      },
      careers: {
        benefits: 'benefits',
        culture: 'our-culture',
        intro: 'who-we-are',
        jobs: 'high-demand-jobs',
        overview: 'overview',
        values: 'our-values',
      },
      products: {
        intro: 'what-we-do',
        overview: 'overview',
        products: 'product-range',
        quality: 'quality-policy',
      },
      sustainability: {
        framework: 'our-framework',
        highlights: 'highlights',
        importance: 'why-is-it-important-for-us',
        overview: 'overview',
        priorities: 'priority-areas',
      },
    },
    labels: {
      about: {
        community: 'In the community',
        'directors-board': 'Board of Directors',
        intro: 'Who are we ?',
        'our-purpose': 'Our purpose',
        overview: 'Overview',
        products: 'Product lines',
      },
      careers: {
        benefits: 'Benefits',
        culture: 'Our culture',
        intro: 'Who we are',
        jobs: 'High-demand jobs',
        overview: 'Overview',
        scholarships: 'Bridge Scholarship Programs',
        values: 'Our values',
      },
      products: {
        intro: 'What we do ?',
        overview: 'Overview',
        products: 'Product range',
        quality: 'Quality Policy',
      },
      sustainability: {
        framework: 'Our framework',
        highlights: 'Highlights',
        importance: 'Why is it important for us ?',
        overview: 'Overview',
        priorities: 'Priority areas',
      },
    },
  },
  business_unit: 'Business Unit',
  company_name: 'CRH Canada Group inc.',
  compliance_label: 'Compliance',
  contact_us: 'Contact Us',
  credits: ':YEAR © CRH Canada \\| All rights reserved',
  filter_by: 'Filter by',
  find_a_location: 'Find a location',
  gdpr: {
    banner: {
      title: 'Our use of cookies',
      description:
        'We use cookies to make this site work and to help us make improvements. Clicking accept will enable us to set recommended analytics cookies.',
      accept: 'ACCEPT COOKIES',
      settings: 'CHANGE COOKIES SETTINGS',
    },
    settings: {
      title: 'Our use of cookies',
      description:
        "We use essential cookies to make our site work. We'd also like to set optional analytics cookies to help us improve it. We won't set optional cookies unless you enable them. Using this tool will set a cookie on your device to remember your preferences. For more detailed information about the cookies we use, see our Privacy & Cookies page.",
      essentials: {
        title: 'Essential cookies',
        description:
          'Essential cookies enable core functionality such as security, network management, and accessibility. You may disable these by changing your browser settings, but this may affect how the website functions.',
      },
      analytics: {
        title: 'Analytics cookies',
        description:
          "We'd like to set Google Analytics cookies to help us to improve our website by collecting and reporting information on how you use it. The cookies collect information in a way that does not directly identify anyone. For more information on how these cookies work, please see our Privacy & Cookies page.",
      },
      save: 'Save and close',
    },
  },
  learn_more: 'Read more',
  not_found: {
    label: 'Go to homepage',
    text: {
      bottom:
        "Take a look around or get in touch with us if you can't find what you're looking for",
      top: "The page you're looking for doesn't seem to exist",
    },
    title: 'Page not found',
  },
  office: 'Office',
  or: 'or',
  other_sites: 'Other Sites',
  policies: {
    accessibility: 'Accessibility',
    disclaimer: 'Disclaimer',
    privacy: 'Privacy & Cookies',
    sms: 'SMS Terms',
  },
  post: {
    anchor: 'posts',
    latest: {
      legend: 'Latest news',
      title: 'Discover the latest news from the CRH Canada ecosystem and its Business Units',
    },
    mail: {
      body: 'Check out this article. Clic on the link below : ',
      subject: 'This article is recommended for you',
    },
    return: 'Back to Blog',
    share: 'Share this news',
  },
  product: {
    anchor: 'products',
  },
  product_type: 'Product Type',
  search_by_location: 'Search by location',
  see_more: 'See more',
  seo: {
    fallback: {
      description: 'CRH is one of the largest materials and construction companies in Canada.',
      keywords: 'Building, construction, materials, cement, aggregates, asphalt, concrete',
      title: 'CRH Canada',
    },
    not_found: {
      title: 'Page not found | CRH Canada',
    },
  },
  soil_management: 'Soil Management',
}
